var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pull-to',{staticClass:"eds-licence"},[_c('div',{staticClass:"licence"},[_vm._v(_vm._s(_vm.licence))])])
}
var staticRenderFns = []

export { render, staticRenderFns }